import { useMemo } from 'react';
import {
  TimeSignalAnalyticsQuery,
  TimeSignalDimensionType,
  useTimeSignalAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from 'modules/Insights/Notes/NoteInsightsContextProvider';

export const useGetTimeSignalAnalyticsData = (
  dimension: TimeSignalDimensionType
): {
  data: TimeSignalAnalyticsQuery | undefined;
  loading: boolean;
  isEmpty: boolean;
} => {
  const { currentPeriod } = useNoteInsightsContext();
  const { startDate, endDate } = currentPeriod ?? {};
  const { loading, data } = useTimeSignalAnalyticsQuery({
    variables: {
      input: {
        dimension,
        filter: {
          fromDate: startDate,
          toDate: endDate
        }
      }
    }
  });
  return useMemo(
    () => ({
      data,
      loading,
      isEmpty: data?.timeSignalAnalytics?.items.dimensions.length === 0
    }),
    [data, loading]
  );
};
